import Api from '../_base';

class PlanApi {
	async getPlanList(store) {

		const query = store ?  `?store=${store}` : '';
		const response = await Api.get(`/plans${query}`, false);

		return {
			data: response.data,
			status: response.status,
			statusText: response.statusText
		};
	}
}

export default new PlanApi();
